/**
 * @generated SignedSource<<cbbb0d0ea1b4cfaa7bcc26d6d9f8e5cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type onboardingPage_LeadQuery$variables = {
  token?: string | null | undefined;
};
export type onboardingPage_LeadQuery$data = {
  readonly lead: {
    readonly answers: ReadonlyArray<{
      readonly fields: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
      readonly key: string;
      readonly values: ReadonlyArray<string>;
    }>;
    readonly completenessScore: number;
    readonly converted: boolean;
    readonly currentStepKey: string | null | undefined;
    readonly email: string | null | undefined;
    readonly firstName: string | null | undefined;
    readonly integrations: ReadonlyArray<{
      readonly available: boolean;
      readonly connectUrl: string | null | undefined;
      readonly connected: boolean;
      readonly displayName: string | null | undefined;
      readonly provider: string;
    }>;
    readonly lastName: string | null | undefined;
    readonly position: number | null | undefined;
    readonly referralCode: string | null | undefined;
    readonly status: string;
    readonly token: string;
    readonly uploadedFiles: ReadonlyArray<{
      readonly byteSize: number | null | undefined;
      readonly coverageEnd: string | null | undefined;
      readonly coverageStart: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly filename: string | null | undefined;
      readonly id: string;
      readonly parseState: string;
      readonly sourceId: string;
      readonly txnCount: number;
    }>;
    readonly waitDays: number | null | undefined;
  } | null | undefined;
  readonly me: {
    readonly accessGrantedAt: string | null | undefined;
  } | null | undefined;
};
export type onboardingPage_LeadQuery = {
  response: onboardingPage_LeadQuery$data;
  variables: onboardingPage_LeadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessGrantedAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "token",
      "variableName": "token"
    }
  ],
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStepKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "converted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completenessScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnboardingAnswer",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "values",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OnboardingAnswerField",
          "kind": "LinkedField",
          "name": "fields",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnboardingUploadedFile",
      "kind": "LinkedField",
      "name": "uploadedFiles",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "byteSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "txnCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverageStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverageEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parseState",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnboardingIntegration",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "provider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "available",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "connected",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "connectUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "onboardingPage_LeadQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboardingPage_LeadQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7668b07bcf10090f892153e6673d9981",
    "id": null,
    "metadata": {},
    "name": "onboardingPage_LeadQuery",
    "operationKind": "query",
    "text": "query onboardingPage_LeadQuery(\n  $token: String\n) {\n  me {\n    accessGrantedAt\n    id\n  }\n  lead(token: $token) {\n    token\n    firstName\n    lastName\n    email\n    status\n    currentStepKey\n    converted\n    completenessScore\n    position\n    waitDays\n    referralCode\n    answers {\n      key\n      values\n      fields {\n        key\n        value\n      }\n    }\n    uploadedFiles {\n      id\n      filename\n      sourceId\n      byteSize\n      txnCount\n      coverageStart\n      coverageEnd\n      parseState\n      errorMessage\n    }\n    integrations {\n      provider\n      available\n      connected\n      displayName\n      connectUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3babdebbf1bf32e8c8b9dc9902fa772c";

export default node;
